import { useState } from 'react';

import {
  useMutation,
  useQueryClient
} from '@sopranodesign/pulse-hooks';

export function useTagManager({ scope, createTagFn }) {
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const queryClient = useQueryClient();

  const createTagMutation = useMutation({
    mutationFn: createTagFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tags', scope] });
    }
  });

  const handleTagChange = async (selectedOptions) => {
    const items = selectedOptions || [];
    const processedTags = await Promise.all(
      items.map(async ({ __isNew__, ...item }) => {
        if (__isNew__) {
          const { data } = await createTagMutation.mutateAsync({
            name: item.value,
            scoped_to: scope
          });
          return { value: data.data.id, label: data.data.name };
        }
        return item;
      })
    );

    const tagIds = processedTags.map(option => option.value);
    setSelectedTags(tagIds);

    const newTags = processedTags.map(t => ({ id: t.value, name: t.label }));
    setTags(prevTags => {
      const existingIds = prevTags.map(tag => tag.id);
      const uniqueNewTags = newTags.filter(tag => !existingIds.includes(tag.id));
      return [...prevTags, ...uniqueNewTags];
    });
  };

  return { tags, selectedTags, setSelectedTags, handleTagChange, setTags };
}
